module.exports = __webpack_public_path__ + "img/notebook.827bc4d4.png";